import IconStarFish from '../../../assets/icons/ic-starfish.svg';
import ImgAboutUs1 from '../../../assets/images/img-about-us1.png';
import ImgAboutUs2 from '../../../assets/images/img-about-us4.jpeg';
import ImgAboutUs3 from '../../../assets/images/img-about-us5.jpg';

import IconSquid from '../../../assets/icons/ic-squid.svg';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation('header');

  return (
    <div id="aboutUs" className="relative">
      <div className="absolute top-0 left-[-35px] xl:left-[-100px] -z-10">
        <img src={IconStarFish} alt="star fish" className="w-[94px] xl:w-[240px]" />
      </div>

      <div className="absolute right-[-90px] bottom-[-15%] xl:right-[-200px] xl:bottom-[-75%] -z-10">
        <img src={IconSquid} alt="squid" className="w-[240px] xl:w-auto" />
      </div>

      <div className="grid grid-cols-12 items-center xl:gap-x-[56px] px-4 xl:px-[100px] mt-9 xl:mt-[70px]">
        <div className="col-span-12 xl:col-span-6">
          <span className="font-dancing-script text-orange-300 xl:text-[24px] font-bold">
            {t('about.title')}
          </span>
          <h2 className="xl:mt-2 text-primary text-[24px] xl:text-[32px] font-bold xl:font-extrabold">
            {t('about.welcome')}
          </h2>
          <p className="mt-4 text-grey-100 text-[14px] xl:text-[16px] leading-5 xl:leading-[22px]">
            {t('about.introduce')}
          </p>
        </div>
        <div className="col-span-12 xl:col-span-6 relative">
          <div className="xl:absolute xl:left-0 xl:top-[50%] xl:translate-y-[-50%] xl:border-[20px] xl:border-white mt-4 xl:mt-0">
            <img src={ImgAboutUs1} alt="about us 1" className="w-full xl:w-auto" />
          </div>
          <div className="w-full mt-4 xl:mt-0">
            <img
              src={ImgAboutUs2}
              alt="about us 2"
              className="w-full xl:w-[357px] xl:h-[316px] ml-auto"
            />
            <img
              src={ImgAboutUs3}
              alt="about us 3"
              className="w-full ml-auto mt-4 xl:mt-5 xl:w-[357px] xl:h-[316px]"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
